import { UsersApi2 } from "@/Apis/UsersApi2";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useUsersApi2(): UsersApi2 {
  const { accessToken } = useAuthentication();

  return new UsersApi2(getConfig().basePath, accessToken);
}
